import React, { useEffect, useState } from "react";
import useStyles from "../../../../components/common/model/styles";
import Popup from "../../../../components/common/model/Popup";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import closeIcon from "../../../../assets/closeModel.png";
import CustomButton from "../../../../components/common/button/CustomButton";
import { useDispatch } from "react-redux";

import Notification from "../../../../components/common/notification/Notification";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";

interface DeleteAlertPopupProps {
  title?: string;
  open?: boolean;
  onHide?: () => void;
  alertModalShow?: any;
  setAlertModelShow?: (show: boolean) => void;
  onConfirm?: () => void;
}
const DeleteAlert: React.FC<DeleteAlertPopupProps> = ({
  onHide,
  title,
  alertModalShow,
  setAlertModelShow,
  onConfirm,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const submitHandler = () => {
    if (onConfirm) {
      onConfirm(); // <-- call parent function
    }
  };
  const closeModel = () => {
    if (setAlertModelShow) {
      setAlertModelShow(false);
    }
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  return (
    <Popup
      open={alertModalShow}
      title={"Delete Service Record"}
      onHide={closeModel}
      fullWidth={true}
      maxWidth={"xs"}
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={closeModel}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
          <CustomButton variant="outlined" title="No" onClick={closeModel} />
          <CustomButton title="Yes" onClick={submitHandler} />
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>
          <Notification />
          <Alert
            sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
            severity="warning"
          >
            Are you sure you want to delete this service record ?
          </Alert>
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default DeleteAlert;
